const TTL_MS = 180_000; // 3 minutes

type StoredEntry = { hash: string; timestamp: number };

export const getStoredIdempotencyHash = (command: string): string | null => {
  try {
    const raw = localStorage.getItem(`idempotency_${command}`);
    if (!raw) return null;
    const entry: StoredEntry = JSON.parse(raw);
    if (Date.now() - entry.timestamp > TTL_MS) return null;
    return entry.hash;
  } catch {
    return null;
  }
};

export const storeIdempotencyHash = (command: string, hash: string): void => {
  try {
    localStorage.setItem(
      `idempotency_${command}`,
      JSON.stringify({ hash, timestamp: Date.now() }),
    );
  } catch {
    // localStorage may be unavailable in some environments
  }
};
